
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/monitoring-evaluation-and-research-department",
      function () {
        return require("private-next-pages/monitoring-evaluation-and-research-department.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/monitoring-evaluation-and-research-department"])
      });
    }
  